import { Link, type LinkProps } from '@/components/ui/link';

import { newsStyles } from './styles';

export type WhatsNewLinkProps = LinkProps;
export function WhatsNewLink({ className, ...props }: WhatsNewLinkProps) {
  const styles = newsStyles();

  return (
    <Link
      {...props}
      className={styles.primary({ className: styles.clickable({ className }) })}
    />
  );
}
